/**
 * Google Analytics の初期化 (JPTP_CANSEI-1400)。
 *
 * 測定 ID は prod / stg に設定する (infrastructure/deploy/guest/{production,staging}.jsonc)。
 * データストリームは環境ごとに分かれている。ローカル / dev は空のままにし、全送信を no-op にする。
 * 未定義だとバンドルに process.env が残り ReferenceError になるため、空でも定義しておく。
 *
 * 初回の page_location も伏字処理済みの URL にする。config が発火させる初回イベントにも
 * アクセストークンを載せないため、React の描画より前 (frontend.tsx の import 時) に実行する。
 */
import { initAnalytics } from "@viajero/shared-ui/analytics";
import { redactPath } from "@/lib/analytics/redactPath";

initAnalytics(process.env.BUN_PUBLIC_GA_MEASUREMENT_ID, {
  page_location: `${window.location.origin}${redactPath(window.location.pathname)}`,
  page_title: document.title,
});
